import { FC } from 'react';
import './FiligraneCard.scss';
import { ReactComponent as IconFile } from 'assets/img/icons/icon_File2.svg';

export type FiligraneCardSize = 'sm' | 'md' | 'lg' | 'xl';
export type FiligraneCardVariant = 'upload' | 'result';

interface Props {
  id: string;
  name: string;
  previewUrl: string;
  fileType: 'image' | 'pdf';
  isSelected: boolean;
  onToggle: (id: string) => void;
  variant?: FiligraneCardVariant;
  size?: FiligraneCardSize;
  onDelete?: (id: string) => void;
  scanDelay?: number;
}

const FiligraneCard: FC<Props> = ({
  id,
  name,
  previewUrl,
  fileType,
  isSelected,
  onToggle,
  variant = 'upload',
  size = 'sm',
  onDelete,
  scanDelay,
}) => (
  <div className={`filigrane-card filigrane-card--${variant} filigrane-card--${size}`}>
    <div
      className={`filigrane-card__inner${isSelected ? ' filigrane-card__inner--selected' : ''}`}
      onClick={() => onToggle(id)}
      role="button"
      tabIndex={0}
      aria-pressed={isSelected}
      onKeyDown={e => e.key === 'Enter' && onToggle(id)}
    >
      <div className="filigrane-card__preview">
        {fileType === 'image' && previewUrl && (
          <img src={previewUrl} alt={name} className="filigrane-card__img" />
        )}
        {fileType === 'pdf' && previewUrl && (
          <div className="filigrane-card__pdf-container">
            <iframe
              src={`${previewUrl}#toolbar=0&navpanes=0&scrollbar=0`}
              title={name}
              className="filigrane-card__pdf-frame"
              tabIndex={-1}
              scrolling="no"
            />
          </div>
        )}
        {!previewUrl && (
          <IconFile fill={"#2f62ae"} className="filigrane-card__file-icon" />
        )}
      </div>

      <span className="filigrane-card__name">{name}</span>

      {isSelected ? (
        <div className="filigrane-card__checkbox" aria-hidden="true">
          <span className="filigrane-card__check">✓</span>
        </div>
      ) : (
        <div className="filigrane-card__uncheckbox" aria-hidden="true" />
      )}

      {variant === 'result' && scanDelay !== undefined && (
        <div
          className="filigrane-card__scan"
          style={{ animationDelay: `${scanDelay}s` }}
          aria-hidden="true"
        />
      )}
    </div>

    {variant === 'result' && onDelete && (
      <button
        className="filigrane-card__delete"
        onClick={e => { e.stopPropagation(); onDelete(id); }}
        aria-label={`Supprimer ${name}`}
      >
        <span>✕</span>
      </button>
    )}
  </div>
);

export default FiligraneCard;
